module.exports = __webpack_public_path__ + "static/media/joerg-dittmann.482a2d29.jpg";